import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // ticket
  	isMobile: false,
  	actionUrl: '',
    ticketDetail: {},
    selectGroup: {},
    museumName: '',
    hasShowPop: false,
    hasGetCode: false,
    writePhone: '',
    themeData: {},
    userPhone: ''
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
